import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeftSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronLeftSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M13.9395 7.64645C13.7442 7.45118 13.4276 7.45118 13.2324 7.64645L9.93949 10.9393C9.3537 11.5251 9.3537 12.4749 9.93949 13.0607L13.2324 16.3536C13.4276 16.5488 13.7442 16.5488 13.9395 16.3536C14.1348 16.1583 14.1348 15.8417 13.9395 15.6464L10.6466 12.3536C10.4513 12.1583 10.4513 11.8417 10.6466 11.6464L13.9395 8.35355C14.1348 8.15829 14.1348 7.84171 13.9395 7.64645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeftSmall;
